import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import {
  BotaoStep,
  CheckboxUnform,
  FormUnform,
  scrollParaTopo,
  WizardContainer
} from 'src/componentes'
import { Api } from 'src/servicos'

import RescisaoContainer from '../../container'
import {
  ContainerAcoes,
  ContainerCheckbox,
  ContainerConteudo
} from '../../styles'

/**
 * TELA 1 — Avisos e termos iniciais (§3 da PROPOSTA).
 * O aceite aqui é só ciência (registra data/hora/IP) — não efetiva a rescisão
 * nem muda a situação da matrícula.
 */
export const EtapaAvisos: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const { protocolo, definirPasso } = RescisaoContainer.useContainer()
  const { mudarEtapa } = WizardContainer.useContainer()
  const [carregando, definirCarregando] = useState(false)
  const [estouCiente, definirEstouCiente] = useState(
    Boolean(protocolo?.aceitouTermosIniciais)
  )

  useEffect(() => {
    scrollParaTopo()
  }, [])

  const avancar = async () => {
    try {
      definirCarregando(true)
      await Api.AceitarTermosIniciais(id)
      mudarEtapa(2)
      definirPasso(2)
    } finally {
      definirCarregando(false)
    }
  }

  return (
    <ContainerConteudo>
      <h2>Antes de prosseguir com o seu pedido</h2>
      <p>
        Ficamos tristes em saber do seu interesse em realizar a rescisão de
        contrato conosco. Ressaltamos alguns pontos importantes:
      </p>
      <ul>
        <li>
          A taxa rescisória é de {protocolo?.percentualTaxaRescisao ?? 15}%
          sobre o valor a vencer somado ao valor integral das parcelas
          vencidas, caso tenha.
        </li>
        <li>
          A multa deverá ser paga integralmente em cota única, podendo ser
          parcelada apenas via cartão de crédito.
        </li>
        <li>
          Não serão devolvidos valores de parcelas já pagas, bem como encargos
          de mora sobre eventuais parcelas vencidas.
        </li>
        <li>
          Não trabalhamos com a opção de trancamento de matrícula, apenas de
          rescisão contratual.
        </li>
        <li>
          O pedido de rescisão é válido por 30 dias; passado o prazo, será
          necessária a abertura de novo protocolo.
        </li>
      </ul>
      <FormUnform
        acaoSucesso={avancar}
        dadosIniciais={{ estouCiente }}
      >
        <ContainerCheckbox>
          <CheckboxUnform
            id="chk_ciente_rescisao"
            name="estouCiente"
            onChange={() => definirEstouCiente(old => !old)}
          />
          <label htmlFor="chk_ciente_rescisao">
            Estou ciente dos pontos acima e desejo continuar com o pedido de
            rescisão
          </label>
        </ContainerCheckbox>
        <ContainerAcoes>
          <span />
          <BotaoStep
            texto="Ir para"
            textoNegrito="Valores da Rescisão"
            type="submit"
            carregando={carregando}
            disabled={!estouCiente}
            textoTooltip={
              !estouCiente
                ? 'Para continuar, marque que está ciente dos pontos acima'
                : undefined
            }
          />
        </ContainerAcoes>
      </FormUnform>
    </ContainerConteudo>
  )
}
